<template>
  <vx-card>
    <loading v-if="showLoading"></loading>
    <div v-if="!showLoading" class="vx-row mb-6">
      <div class="vx-col w-full mt-1">
        <label class="vs-input--label">{{ $t("ContractName") }}</label>
        <div class="w-full">
          <v-select
            label="title"
            :options="allContracts"
            v-model="contractId"
            :reduce="x => x.id"
            @input="selectContract"
            :clearable="false"
            dir="rtl"
          >
          </v-select>
        </div>
      </div>
    </div>
    <div v-if="updateData">
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-tabs vs-alignment="fixed" alignment="fixed">
            <vs-tab :label="$t('BasicInfo')" class="mt-4">
              <basic-info :contractId="contractId"></basic-info>
            </vs-tab>
            <vs-tab :label="$t('SaleFactors')" class="mt-4">
              <orders :contractId="contractId"></orders>
            </vs-tab>
            <vs-tab :label="$t('SaleItemsInfo')" class="mt-4">
              <order-items :contractId="contractId"></order-items>
            </vs-tab>
            <vs-tab :label="$t('BestSellers')" class="mt-4">
              <best-sellers :contractId="contractId"></best-sellers>
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
    </div>
  </vx-card>
</template>
<script>
import vSelect from "vue-select";
import { mapGetters, mapActions } from "vuex";
import BasicInfo from "../Contract/BasicInfo/Index.vue";
import Orders from "../Contract/Orders/Index.vue";
import OrderItems from "../Contract/OrderItems/Index.vue";
import BestSellers from "../Contract/BestSellers/Index.vue";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "saleManagement_Reports_Contract_Index",

  computed: {
    ...mapGetters({
      allContracts: "sale/list"
    })
  },
  data() {
    return {
      showLoading: true,
      contractId: null,
      updateData: false
    };
  },
  mounted() {
    this.fetchContract().then(() => {
      this.showLoading = false;
    });
  },
  methods: {
    ...mapActions({
      fetchContract: "sale/fetchNoSkip"
    }),
    selectContract() {
      if (this.updateData) {
        this.updateData = false;
        setTimeout(() => {
          this.updateData = true;
        }, 1000);
      } else {
        this.updateData = true;
      }
    }
  },
  components: {
    "v-select": vSelect,
    BasicInfo,
    Orders,
    OrderItems,
    BestSellers,
    Loading
  }
};
</script>
